export async function loadRemoteApplications(url, scope, timeout = 10000) {
  return new Promise((resolve) => {
    if (window[scope]) return resolve(true);

    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(ok);
    };

    const timer = setTimeout(() => {
      console.warn(`[MF] Timeout loading remote: ${url}`);
      script.remove();
      finish(false);
    }, timeout);

    script.onload = () => {
      console.log(`[MF] Remote loaded: ${url}`);
      finish(true);
    };

    script.onerror = () => {
      console.warn(`[MF] Failed to load remote: ${url}`);
      finish(false);
    };

    document.head.appendChild(script);
  });
}

export async function loadRemoteApps() {
  const env = process.env
  const remoteEnvKeys = Object.keys(env).filter(key =>
    key.endsWith("_HOST_WP")
  );
  for (const key of remoteEnvKeys) {
    const url = process.env[key];
    if (!url || url.trim() === "") {
      console.warn(`Module federation Skipping ${key} — URL is not configured`);
      continue;
    }
    const name = key.replace("_HOST_WP", "");
    const loaded = await loadRemoteApplications(url+'/remoteEntry.js', `MHEA_${name}`, 10000);
    if (loaded) {
      console.log(`${name} remote loaded successfully`);
      await __webpack_init_sharing__("default");
      const container = window[`MHEA_${name}`];
      await container.init(__webpack_share_scopes__.default);
    } else {
      console.warn(`${name} remote unavailable — host continues.`);
    }
  }
}


